// src/components/Login.js
import React, { useState } from 'react';
import { auth, db } from '../firebase';
import {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword
} from 'firebase/auth';
import {
  Box,
  TextField,
  Button,
  Typography,
  Alert
} from '@mui/material';
import { doc, setDoc } from 'firebase/firestore';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  // This state determines if we are in "login" or "signup" mode
  const [isSignUp, setIsSignUp] = useState(false);

  // Handle Login
  const handleLogin = async () => {
    setError('');
    try {
      await signInWithEmailAndPassword(auth, email, password);
      // Handle successful login here
    } catch (err) {
      setError(err.message);
    }
  };

  // Handle Sign Up
  const handleSignUp = async () => {
    setError('');
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      await setDoc(doc(db, 'users', userCredential.user.uid), {
        energy: 100
      });
      // Handle successful signup here (e.g., redirect or show success message)
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <Box
      sx={{
        position: 'relative',
        p: 2,
        px: 10,
        minHeight: '100vh',
        backgroundColor: 'var(--primary-bg-color)', // defined in app.css
        color: 'var(--text-color)',                  // defined in app.css
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <Typography
        variant="h3"
        sx={{
          mb: 4,
          fontWeight: 'bold',
          color: 'var(--text-color)' // Adjust color as needed
        }}
      >
        Chlo
      </Typography>

      <Box
        sx={{
          maxWidth: '400px',
          width: '100%',
          backgroundColor: 'var(--accent-bg-color)',
          p: 3,
          borderRadius: '8px',
          boxShadow: '0 4px 8px rgba(0,0,0,0.4)'
        }}
      >
        <Typography
          variant="h5"
          sx={{
            mb: 2,
            fontWeight: 'bold'
          }}
        >
          {isSignUp ? 'Sign Up' : 'Login'}
        </Typography>

        {error && (
          <Alert
            severity="error"
            sx={{
              backgroundColor: '#1a1a1a',
              color: '#ffffff',
              mb: 2,
              borderRadius: '4px',
              border: '1px solid #333'
            }}
          >
            {error}
          </Alert>
        )}

        <TextField
          label="Email"
          fullWidth
          margin="normal"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          InputProps={{
            sx: {
              color: '#ffffff',
              backgroundColor: '#121212',
              borderRadius: '8px',
              '&.MuiOutlinedInput-root fieldset': { borderColor: '#444' },
              '&:hover fieldset': { borderColor: '#ffffff !important' },
              '&.Mui-focused fieldset': { borderColor: '#ffffff !important' }
            }
          }}
          InputLabelProps={{ style: { color: '#ffffff' } }}
        />

        <TextField
          label="Password"
          type="password"
          fullWidth
          margin="normal"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          InputProps={{
            sx: {
              color: '#ffffff',
              backgroundColor: '#121212',
              borderRadius: '8px',
              '&.MuiOutlinedInput-root fieldset': { borderColor: '#444' },
              '&:hover fieldset': { borderColor: '#ffffff !important' },
              '&.Mui-focused fieldset': { borderColor: '#ffffff !important' }
            }
          }}
          InputLabelProps={{ style: { color: '#ffffff' } }}
        />

        <Button
          variant="contained"
          onClick={isSignUp ? handleSignUp : handleLogin}
          sx={{
            backgroundColor: '#333333',
            color: '#ffffff',
            '&:hover': { backgroundColor: '#555555' },
            '&.Mui-disabled': {
              color: '#aaaaaa',
              backgroundColor: '#111111'
            },
            width: '100%',
            height: '50px',
            borderRadius: '30px',
            boxShadow: 'none',
            mt: 2,
            textTransform: 'none'
          }}
        >
          {isSignUp ? 'Sign Up' : 'Login'}
        </Button>

        <Typography
          variant="body2"
          sx={{ mt: 2, textAlign: 'center', color: '#ffffff' }}
        >
          {isSignUp ? 'Already have an account?' : "Don't have an account?"}{' '}
          <Button
            color="inherit"
            sx={{
              textDecoration: 'underline',
              textTransform: 'none',
              p: 0,
              minWidth: 'auto'
            }}
            onClick={() => setIsSignUp(!isSignUp)}
          >
            {isSignUp ? 'Login' : 'Sign Up'}
          </Button>
        </Typography>
      </Box>
    </Box>
  );
};

export default Login;
